__webpack_require__.p = "/bmi/";